import {ModalController} from "react-modal-global";
export const ErrorModal   = new ModalController()
